const {
  groupByDate,
  dateGroupCollapsedByDefault,
} = require('./dateGroups');
const { isSystemChatHead } = require('./insideChatHeader');

function chatUsesDateSeparators(chat) {
  if (!chat) return false;
  if (chat.groupId != null && chat.groupId !== '') return true;
  return isSystemChatHead(chat);
}

function replyClusterDate(message, messages) {
  if (!message) return null;
  const sourceId = message._replyContext
    ? message._replyContextSourceId
    : message.isReply
      ? message.isReplyTo
      : null;
  if (sourceId == null || sourceId === '') return message.datetime;
  let latest = null;
  let latestTime = -Infinity;
  for (const row of messages) {
    if (!row || !row.isReply) continue;
    if (String(row.isReplyTo) !== String(sourceId)) continue;
    const time = new Date(row.datetime).getTime();
    if (Number.isFinite(time) && time >= latestTime) {
      latestTime = time;
      latest = row.datetime;
    }
  }
  return latest || message.datetime;
}

function systemChatDateGroups(messages, now = new Date()) {
  const list = Array.isArray(messages) ? messages : [];
  const groups = groupByDate(list, now, (row) => replyClusterDate(row, list));
  return groups.slice().reverse();
}

function systemChatPanelRows(messages, collapsed, now = new Date()) {
  const closed = collapsed || {};
  const rows = [];
  for (const group of systemChatDateGroups(messages, now)) {
    rows.push({
      kind: 'header',
      key: `date-${group.key}`,
      group,
    });
    if (closed[group.key]) continue;
    for (const message of group.items) {
      rows.push({
        kind: 'message',
        key: String(message.id != null ? message.id : message.datetime),
        message,
      });
    }
  }
  return rows;
}

function defaultSystemDateCollapsed() {
  return {
    today: dateGroupCollapsedByDefault('today'),
    yesterday: dateGroupCollapsedByDefault('yesterday'),
    week: dateGroupCollapsedByDefault('week'),
    older: dateGroupCollapsedByDefault('older'),
  };
}

function conversationPanelRowsFor(chat, messages, collapsed, now = new Date()) {
  const list = Array.isArray(messages) ? messages : [];
  if (!chatUsesDateSeparators(chat)) {
    return list.map((message) => ({
      kind: 'message',
      key: String(message.id != null ? message.id : message.datetime),
      message,
    }));
  }
  return systemChatPanelRows(list, collapsed, now);
}

module.exports = {
  chatUsesDateSeparators,
  conversationPanelRowsFor,
  defaultSystemDateCollapsed,
  systemChatDateGroups,
  systemChatPanelRows,
};
